"use client"

import styled from "@emotion/styled"
import React from "react"
import { transformProperties } from "utils/simplifyData"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import { mediaQueries } from "../theme/mediaQueries"
import BulletCard, { BulletCardItem } from "./BulletCard"

interface BulletsCardsListProps {
  itemList: BulletCardItem[]
  onButtonClick?: (item: BulletCardItem, categoryName?: string) => void
  categoryName?: string
}

const StyledBulletCardList = styled(SwiperOnMobile, {
  shouldForwardProp: (prop) => prop !== "cardHeight",
})<{ cardHeight?: string }>`
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  overflow: visible;
  ${mediaQueries.tablet} {
    height: ${(prop) => prop.cardHeight};
  }
  ${mediaQueries.desktopM} {
    height: ${(prop) => prop.cardHeight};
  }
`

const BulletsCardsListMobileSwiper: React.FC<BulletsCardsListProps> = ({
  itemList,
  onButtonClick,
  categoryName,
}) => {
  return (
    <StyledBulletCardList
      swiperProps={{
        slidesPerView: 1,
        navigation: true,
        loop: false,
        autoHeight: true,
      }}
    >
      {itemList &&
        itemList.map((item, index) => {
          const { title } = transformProperties(item?.properties)
          return (
            <BulletCard
              key={`bullet-card-${title.value}-${index + 1}`}
              item={item}
              buttonVariant={"outlined"}
              onButtonClick={onButtonClick}
              categoryName={categoryName}
            />
          )
        })}
    </StyledBulletCardList>
  )
}

export default BulletsCardsListMobileSwiper
